import ReactDOM from "react-dom/client";
import "./index.css";
import ThemeConfig from "./theme";
import { ConfigProvider } from "./contexts/ConfigContext";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ThemeConfig>
    <ConfigProvider>
      <App />
    </ConfigProvider>
  </ThemeConfig>
);
